<template>
    <div>
        <!-- 报警记录 -  报警对象列 -->
        <!-- 邮件通知 -->
        <!-- <i class="el-icon-postcard icon icon-margin cursor-pointer" :title="$t('integration.mail')"
            :style="row['alarm_way'][6] === '1' && 'color:#344962'"></i> -->
        <!-- 短信通知 -->
        <!-- <i class="el-icon-message icon icon-margin cursor-pointer" :title="$t('integration.short_message')"
            :style="row['alarm_way'][5] === '1' && 'color:#344962'"></i> -->
        <!-- 语音通知 -->
        <!-- <i class="el-icon-phone-outline icon icon-margin cursor-pointer" :title="$t('integration.voice')"
            :style="row['alarm_way'][4] === '1' && 'color:#344962'"></i> -->
        <el-popover width="300" trigger="hover">
            <div class="uk-text-center lh-30">
                <div class="uk-flex border r-5 mb-5" v-if="way[0] === '1'">
                    <div class="bg-theme color-white title-width">{{ $t('integration.mail') }}</div>
                    <div class="pl-5 uk-flex-1">{{ row.email }}</div>
                </div>

                <div class="uk-flex border r-5 mb-5" v-if="way[1] === '1'">
                    <div class="bg-theme color-white title-width">{{ $t('integration.short_message') }}</div>
                    <div class="pl-5 uk-flex-1">{{ row.mobile }}</div>
                </div>

                <div class="uk-flex border r-5" v-if="way[2] === '1'">
                    <div class="bg-theme color-white title-width">{{ $t('integration.voice') }}</div>
                    <div class="pl-5 uk-flex-1">{{ row.mobile }}</div>
                </div>
            </div>
            <span slot="reference">{{ row[index] }}</span>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: ['row', 'index'],
    computed: {
        way() {
            let way = this.row.alarmWay;
            while (way.length !== 3) {
                way = '0' + way;
            }
            return way;
        }
    }
};
</script>

<style scoped lang="scss">
::v-deep .title-width {
    width: 100px;
}
</style>
